module.exports = __webpack_public_path__ + "01_veryshort_gold.0ea80710.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_veryshort_gold.png
// module id = ebKS
// module chunks = 0